module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp3_5012.4569f53a.png";